import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { Outlet } from 'react-router';

import { BackgroundBranding } from '@/components/background/BackgroundBranding.comp.tsx';
import { EmailWindow } from '@/components/emailWindow/EmailWindow.comp.tsx';
import {
  appMainStackStyles,
  appOutletStyles,
  appShellStyles,
} from '@/components/layout/appLayout.styles.ts';
import { NavigationProgress } from '@/components/layout/NavigationProgress.comp.tsx';
import { TopBar } from '@/components/layout/topBar/TopBar.comp.tsx';
import { LeftBarNavigation } from '@/components/ui/leftBarNavigation/LeftBarNavigation.comp.tsx';
import { AnnouncementsProvider } from '@/contexts/announcements/AnnouncementsProvider.util.tsx';
import { AppConfigProvider } from '@/contexts/appConfig/AppConfigProvider.util.tsx';
import { DictionariesContextProvider } from '@/contexts/dictionaries/DictionariesContextProvider.util.tsx';
import { DraggableContext } from '@/contexts/draggableContext/Draggable.context.tsx';
import { InfoPanelProvider } from '@/contexts/infoPanel/InfoPanelProvider.util.tsx';
import { UserContextProvider } from '@/contexts/userContext/UserContextProvider.util.tsx';
import { UserContextVerifier } from '@/contexts/userContext/UserContextVerifier.util.tsx';
import { HistoryController } from '@/controlers/History.controller.tsx';
import { PostLoginController } from '@/controlers/PostLogin.controller.tsx';
import { SseController } from '@/controlers/Sse.controller.tsx';
import { EmailsContextProvider } from '@/views/emails/context/EmailsContextProvider.tsx';
import { ProcessCreateDialog } from '@/views/processesCreate/ProcessCreateDialog.comp.tsx';

export const AppLayout: FC = () => {
  return (
    <>
      <HistoryController />
      <PostLoginController />
      <UserContextProvider>
        <UserContextVerifier>
          <AppConfigProvider>
            <AnnouncementsProvider>
              <InfoPanelProvider>
                <DictionariesContextProvider>
                  <EmailsContextProvider>
                    <DraggableContext>
                      <SseController />
                      <ProcessCreateDialog />
                      <BackgroundBranding />
                      <Stack sx={appShellStyles}>
                        <NavigationProgress />
                        <TopBar />
                        <Stack direction="row" id="main-stack" sx={appMainStackStyles}>
                          <LeftBarNavigation />
                          <Box component="main" sx={appOutletStyles}>
                            <Outlet />
                          </Box>
                        </Stack>
                        <EmailWindow />
                      </Stack>
                    </DraggableContext>
                  </EmailsContextProvider>
                </DictionariesContextProvider>
              </InfoPanelProvider>
            </AnnouncementsProvider>
          </AppConfigProvider>
        </UserContextVerifier>
      </UserContextProvider>
    </>
  );
};
